// extracted by mini-css-extract-plugin
export default {"header":"CategoryList_header__eNL4D","imageWrapper":"CategoryList_imageWrapper__HiPqD","image":"CategoryList_image__wBttn","row":"CategoryList_row__wZ9Vw"};